module.exports = __webpack_public_path__ + "static/img/barcode.287f891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barcode.jpg
// module id = thFw
// module chunks = 2